<template>
  <div id="bannerMain">
    <!-- 导航 -->
    <nav class="nav-main nav-position">
      <Menu
        mode="horizontal"
        :active-name="menuIndex"
        class="nav-ul"
        @on-select="handleSelect"
      >
        <MenuItem name="1">首页</MenuItem>
        <MenuItem name="2">门票</MenuItem>
        <MenuItem name="5" v-if="isTourname">旅游卡</MenuItem>
        <MenuItem name="3">攻略</MenuItem>
        <MenuItem name="4">资讯</MenuItem>
      </Menu>
    </nav>
    <!-- <Search v-show="menuIndex === '1' || menuIndex === '2'" /> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import Search from "../../components/search/search.vue";
export default {
  name: "bannerMain",
  data() {
    return {
      homePage: {
        name: "index_home",
        isTourname: true,
      },
    };
  },
  components: {
    // Search,
  },
  created() {
    // 如果路由带有query参数，并且fxsId存在，则显示分销商店铺数据
    let query = this.$route.query;
    if (Object.keys(query).length && query.fxsId) {
      sessionStorage.setItem("fxsId", query.fxsId);
    }
    this.isTourname = sessionStorage.getItem("lgtp") === "02" ? false : true;
  },
  computed: {
    menuIndex() {
      return this.menuRoute(this.$route.path);
      // return String(this.$store.state.app.menuIndex);
    },
    home() {
      return sessionStorage.getItem("fxsId")
        ? {
            ...this.homePage,
            query: {
              fxsId: sessionStorage.getItem("fxsId"),
            },
          }
        : this.homePage;
    },
  },
  methods: {
    menuRoute(route) {
      let menus = {
        "/index_home": "1",
        "/ticket": "2",
        "/travelCard": "5",
        "/travel": "3",
        "/information": "4",
      };
      return menus[route];
    },
    // 选择菜单（MenuItem）时触发
    handleSelect(name) {
      this.$store.commit("setMenuIndex", name);
      switch (name) {
        case "1":
          this.$router.push(this.home);
          break;
        case "2":
          this.$router.push({ name: this.$store.state.app.route });
          break;
        case "3":
          this.$router.push({ name: "travel" });
          break;
        case "4":
          this.$router.push({ name: "information" });
          break;
        case "5":
          this.$router.push({ name: "TravelCard" });
          break;
        default:
          break;
      }
    },
    toPage(num) {
      console.log(num);
    },
  },
};
</script>

<style lang="less" scoped>
#bannerMain {
  position: relative;
  min-width: 1440px;
  .nav-position {
    position: absolute;
    top: -60px;
    left: 0;
    right: 0;
  }
}
</style>
